<template>
  <div class="container-fluid mb-4 font-size-medium p-0">
    <div :class="forConasi ? 'card register-form-conasi' : 'card register-form'">
      <div class="card-body mx-auto" style="max-width: 700px;">
        <form>
          <h4 class="card-title mt-3 text-center text-uppercase">
            {{ $t("register.title") }}
          </h4>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span
                class="input-group-text font-size-medium icon-form-input-class"
              >
                <i class="fa fa-user"></i>
              </span>
            </div>
            <input
              v-model="fullName"
              type="text"
              class="form-control font-size-medium"
              id="inputFullname"
              :placeholder="$t('register.fullName')"
              v-bind:class="{
                'is-invalid': !validRequire(fullName) && fieldBlured,
              }"
              v-on:blur="fieldBlured = true"
            />
            <div class="invalid-feedback" style="text-align: left">
              {{ $t("common.requiredFields") }}
            </div>
          </div>
          <!-- form-group// -->
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span
                class="input-group-text font-size-medium icon-form-input-class"
              >
                <i class="fa fa-envelope"></i>
              </span>
            </div>
            <input
              v-model="email"
              :placeholder="$t('register.email')"
              type="email"
              class="form-control font-size-medium"
              id="inputEmail"
              v-bind:class="{
                'form-control': true,
                'is-invalid': !validRequire(email) && fieldBlured,
              }"
              v-on:blur="fieldBlured = true"
            />
            <div class="invalid-feedback" style="text-align: left">
              {{ $t("common.requiredFields") }}
            </div>
          </div>
          <!-- form-group// -->
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span
                class="input-group-text font-size-medium icon-form-input-class"
              >
                <i class="fa fa-lock"></i>
              </span>
            </div>
            <input
              v-model="password"
              :placeholder="$t('register.password')"
              type="password"
              class="form-control font-size-medium"
              id="inputPassword"
              v-bind:class="{
                'form-control': true,
                'is-invalid': !validRequire(password) && fieldBlured,
              }"
              v-on:blur="fieldBlured = true"
            />
            <div class="invalid-feedback" style="text-align: left">
              {{ $t("common.requiredFields") }}
            </div>
          </div>
          <!-- form-group// -->
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span
                class="input-group-text font-size-medium icon-form-input-class"
              >
                <i class="fa fa-lock"></i>
              </span>
            </div>
            <input
              v-model="confirmPassword"
              :placeholder="$t('register.confirmPassword')"
              type="password"
              class="form-control font-size-medium"
              id="inputConfirmPassword"
              v-bind:class="{
                'form-control': true,
                'is-invalid': !validRequire(confirmPassword) && fieldBlured,
              }"
              v-on:blur="fieldBlured = true"
            />
            <div class="invalid-feedback" style="text-align: left">
              {{ $t("common.requiredFields") }}
            </div>
          </div>
          <!-- form-group// -->
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span
                class="input-group-text font-size-medium icon-form-input-class"
              >
                <i class="fa fa-phone"></i>
              </span>
            </div>
            <input
              v-model="phone"
              :placeholder="$t('register.phone')"
              type="number"
              class="form-control font-size-medium"
              id="inputPhone"
            />
          </div>
          <!-- form-group// -->
          <div v-if="forConasi" class="form-group input-group">
            <div class="input-group-prepend">
              <span
                class="input-group-text font-size-medium icon-form-input-class"
              >
                <i class="fas fa-venus-mars"></i>
              </span>
            </div>
            <select
              class="selectbox-gender form-control font-size-medium"
              id="SelectboxGender"
              v-model="gender"
            >
              <option value="null">{{ $t("register.gender") }}</option>
              <option
                v-for="(item, index) in GenderList"
                :key="item + index"
                :value="item.value"
              >
                {{ $t(item.text) }}
              </option>
            </select>
          </div>
          <!-- form-group end.// -->
          <div v-if="forConasi" class="form-group input-group">
            <div class="input-group-prepend">
              <span
                class="input-group-text font-size-medium icon-form-input-class"
              >
                <i class="fas fa-calendar-alt"></i>
              </span>
            </div>
            <date-picker
              class="form-control font-size-medium"
              :placeholder="$t('register.dateOfBirth')"
              :config="calendar"
              v-model="birtdate"
            ></date-picker>
          </div>
          <!-- form-group// -->
          <!-- <div v-if="forConasi" class="form-group input-group">
            <div class="input-group-prepend">
              <span
                class="input-group-text font-size-medium icon-form-input-class"
              >
                <i class="fas fa-map-marked-alt"></i>
              </span>
            </div>
            <textarea
              name=""
              id=""
              cols="30"
              rows="4"
              v-model="fullAddress"
              :placeholder="$t('register.address')"
              type="text"
              class="form-control font-size-medium"
            ></textarea>
          </div> -->
          <!-- form-group// -->
          <div class="form-group button-register">
            <b-button
              type="submit"
              size="md"
              variant="outline-success"
              class="mb-2"
              @click="onCheckFormRegister($event)"
            >
              {{ $t("common.register") }}
            </b-button>
          </div>
          <div class="justify-center align-center" style="flex-wrap: wrap; display: flex;">
            <div class="col-sm-12 col-md-12 col-lg-12" style="padding: 5px">
              <google-button-component
                v-if="ENABLE_BINDING_GOOGLE"
                :data-width="147"
                :data-text="'signup_with'"
                style="margin: 0"
                @onEmitData="googleBtnEmitData"
              />
            </div>
            <!-- <div class="col-sm-12 col-md-6 col-lg-6" style="padding: 5px">
              <a
                v-if="ENABLE_BINDING_FACEBOOK"
                class="btn btn-primary btn-block btn-social"
                @click="onClickLoginFacebook">
                <i class="fab fa-facebook"/> {{ $t('common.loginWithFacebook') }}
              </a>
            </div> -->
          </div>
          <!-- form-group// -->
          <p class="text-center font-size-medium mt-4">
            {{ $t("register.haveAnAccount") }}
            <span
              class="text-success mouse-pointer"
              @click="goLoginScreen($event)"
              >{{ $t("common.login") }}</span
            >.
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import functionUtils from "Utils/functionUtils";
import LoginFromType from "Enum/loginFromType";
// import DatePicker from "vue2-datepicker";
// import "vue2-datepicker/index.css";
// import "vue2-datepicker/locale/vi";
import stringUtils from "Utils/stringUtils";
import GoogleButtonComponent from 'Components/GoogleButtonComponent'
import { FOR_CONASI_TARGET } from 'Utils/constants'
import SocialNetworkType from 'Enum/socialNetworkType'
export default {
  components: {
    GoogleButtonComponent
    // DatePicker,
  },
  data: () => ({
    username: null,
    email: null,
    password: null,
    confirmPassword: null,
    fullName: null,
    phone: null,
    birtdate: null,
    gender: null,
    fieldBlured: false,
    forConasi: FOR_CONASI_TARGET,
    calendar: {
      format: "DD/MM/YYYY",
      useCurrent: false,
    },
    GenderList: stringUtils.GenderList,
    ENABLE_BINDING_GOOGLE: process.env.VUE_APP_ENABLE_BINDING_GOOGLE.trim() === 'true',
    ENABLE_BINDING_FACEBOOK: process.env.VUE_APP_ENABLE_BINDING_FACEBOOK.trim() === 'true'
  }),
  methods: {
    /**
     * Valid require
     */
    validRequire: function (fieldRequire) {
      if (fieldRequire != "" && fieldRequire != null) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * Set default data
     */
    setDefault: function () {
      this.username = null;
      this.email = null;
      this.password = null;
      this.confirmPassword = null;
      this.fullName = null;
      this.phone = null;
      this.gender = null;
      this.birtdate = null;
    },
    /**
     * Check form register
     */
    onCheckFormRegister: function (event) {
      event.preventDefault();
      this.fieldBlured = true;
      if (
        this.validRequire(this.email) &&
        this.validRequire(this.password) &&
        this.validRequire(this.confirmPassword) &&
        this.validRequire(this.fullName)
      ) {
        if (this.password.trim() != this.confirmPassword.trim()) {
          this.$toast.clear();
          this.$toast.error(
            this.$t("common.notificationToast.passwordIncorrect"),
            {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            }
          );
        } else if (!functionUtils.validateEmail(this.email)) {
          this.$toast.clear();
          this.$toast.error(
            this.$t("common.notificationToast.emailIsIncorrect"),
            {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            }
          );
        } else if (
          !functionUtils.validatePhone(this.phone) &&
          this.validRequire(this.phone)
        ) {
          this.$toast.clear();
          this.$toast.error(
            this.$t("common.notificationToast.incorrectTelephoneNumber"),
            {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            }
          );
        } else if (
          !functionUtils.validateDateOfBirth(this.birtdate) &&
          this.validRequire(this.birtdate)
        ) {
          this.$toast.clear();
          this.$toast.error(
            this.$t("common.notificationToast.incorrectDateOfBirth"),
            {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            }
          );
        } else {
          this.onRegister();
        }
      } else {
        this.$toast.clear();
        this.$toast.error(
          this.$t("common.notificationToast.youAreMissingInformation"),
          {
            position: "bottom-left",
            timeout: 1500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false,
          }
        );
      }
    },
    /**
     * Register
     */
    onRegister: function () {
      // let username = functionUtils.removeSpaceInString(
      //   this.username.toLowerCase()
      // );
      let email = functionUtils.removeSpaceInString(this.email.toLowerCase());
      let lastName = functionUtils.getFirstLastName(this.fullName).lastName;
      let firstName = functionUtils.getFirstLastName(this.fullName).firstName;
      let filter = {
        username: email.trim(),
        email: email.trim(),
        password: this.password.trim(),
        lastName: lastName,
        firstName: firstName,
        birthDate: this.birtdate,
        phone: this.phone,
        gender: this.gender,
        fromDomainType: LoginFromType.CUSTOMER,
        customerUrl: stringUtils.DOMAIN_BASE_PATH,
      };
      this.REGISTER_ACCOUNT(filter)
        .then(
          function () {
            this.setDefault();
            this.$toast.clear();
            this.$toast.success(this.$t("common.notificationToast.success"), {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
            this.$router.push({
              path: "/login",
            });
          }.bind(this)
        )
        .catch(
          function (error) {
            if (!functionUtils.isNull(error.response.data.errorText)) {
              let errorText = error.response.data.errorText;
              this.$toast.clear();
              this.$toast.error(this.$t(errorText), {
                position: "bottom-left",
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false,
              });
            } else {
              this.$toast.clear();
              this.$toast.error(this.$t("login.somethingWentWrong"), {
                position: "bottom-left",
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false,
              });
            }
          }.bind(this)
        );
    },
    /**
     * Go login screen
     */
    goLoginScreen: function () {
      this.$router.push({
        name: "login",
      });
    },
    googleBtnEmitData: function (data) {
      if (data) {
        let id = data.id
        this.checkGoogleLogin(id, SocialNetworkType.GOOGLE, true, data)
      }
    },
    onClickLoginGoogle: function () {
      this.$gAuth
        .signIn()
        .then(GoogleUser => {
          // on success do something
          var profile = GoogleUser.getBasicProfile();
          var fullName = profile.getName()
          var avatarUrl = profile.getImageUrl()
          var email = profile.getEmail()
          if (Object.keys(profile).length > 0) {
            let id = profile.getId()
            let userProfile = {
              fullName: fullName,
              avatarUrl: avatarUrl,
              email: email
            }
            this.checkGoogleLogin(id, SocialNetworkType.GOOGLE, true, userProfile)
          }
        })
        // .catch(error => {
        //   console.log('error', error)
        // })
    },
    checkGoogleLogin: function (socialId, socialType, isProductPortal, extraInfo) {
      let data = {
        socialId: socialId,
        socialType: socialType
      }
      if (extraInfo) {
        data['fullName'] = extraInfo.fullName
        data['avatarUrl'] = extraInfo.avatarUrl
        data['email'] = extraInfo.email
      }
      if (isProductPortal) {
        data['isProductPortal'] = isProductPortal
      }
      this.isLoading = true
      this.REGISTER_WITH_GOOGLE(data).then(
        function () {
          this.$toast.clear()
          this.$toast.success(this.$t('common.notificationToast.success'), {
            position: "bottom-left",
            timeout: 1500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false
          });
          this.SET_USER_DATA();
          this.$router.push({
            path: "/my-voucher",
          });
        }.bind(this)
      ).catch(
        function (error) {
          this.isLoading = false
          if (!functionUtils.isNull(error.response.data.errorText)) {
            let errorText = error.response.data.errorText
            this.$toast.clear()
            this.$toast.error(this.$t(errorText), {
              position: "bottom-left",
              timeout: 2500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          } else {
            this.$toast.clear()
            this.$toast.error(this.$t('login.somethingWentWrong'), {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }
        }.bind(this)
      )
    },
    ...mapActions(["REGISTER_ACCOUNT", "REGISTER_WITH_GOOGLE", "SET_USER_DATA"]),
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.register-form-conasi {
  background-color: transparent;
  border: none;
  form {
    background-color: #f7fafc;
    box-shadow: 0 0px 17px 0 rgba(0, 0, 0, 0.1);
    padding: 15px 30px 3px 30px;
    border-radius: 10px;
    color: $primary;
    ::-webkit-input-placeholder,
    :-ms-input-placeholder,
    ::placeholder {
      font-size: 14px;
      color: $primary;
    }
    input,
    select,
    textarea {
      color: $primary;
    }
  }
  .card-title {
    color: $primary;
  }
  .icon-form-input-class {
    width: 40px;
  }
  .button-register {
    display: flex;
    justify-content: center;
    button {
      background-color: $primary;
      color: #fff;
      border: $primary;
      margin-top: 20px;
      &:hover {
        background-color: #a5563e;
      }
      &:focus {
        box-shadow: 0 0 0 0.2rem rgba(227,137,137,.5);
      }
    }
  }
}
.register-form {
  min-width: 300px;
  background-color: transparent;
  border: none;
  form {
    padding: 15px 30px 3px 30px;
    border-radius: 10px;
    color: $text-second;
    ::-webkit-input-placeholder,
    :-ms-input-placeholder,
    ::placeholder {
      font-size: 14px;
      color: lightgray;
    }
    input,
    select,
    textarea {
      color: $text-input-form;
    }
  }
  .card-title {
    color: $btn-background;
    font-size: 20px;
    font-weight: 600;
  }
  .icon-form-input-class {
    color: $btn-background;
    width: 40px;
  }
  .button-register {
    display: flex;
    justify-content: center;
    button {
      background-color: $btn-background;
      color: $text-primary;
      border: $btn-background;
      padding: .5em 3em;
      &:hover {
        background-color: #a5563e;
      }
      &:focus {
        box-shadow: 0 0 0 0.2rem rgba(227,137,137,.5);
      }
    }
  }
}

.btn-social {
  position: relative;
  padding-left: 44px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  height: 34px;
}

.btn-social>:first-child {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 32px;
  height: 100%;
  line-height: 34px;
  font-size: 1.6em;
  text-align: center;
  border-right: 1px solid rgba(0,0,0,0.2);
}

.btn-google {
  color: #fff;
  border-color: rgba(0,0,0,0.2);
  background: rgb(66, 133, 244);
}
</style>
